// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__-3tQw","introduction":"Faq_introduction__L0m2R","card":"Faq_card__1ufo5","cards":"Faq_cards__X94o6","item":"Faq_item__GGzpr"};